import React from 'react'

import { observer } from 'mobx-react'
import { classList } from 'react-classlist-helper'

export enum LocationsTab {
  Objects = 'objects',
  Controls = 'controls',
  Forms = 'forms',
  Properties = 'properties',
}

interface ITabObject {
  title: string
  page: LocationsTab
}

interface IProps {
  activeTab: LocationsTab
  onTabClick: (tab: LocationsTab) => void
}

function LocationsSetupTabs({ activeTab, onTabClick }: IProps) {
  const tabObjects: ITabObject[] = [
    { title: 'Objects', page: LocationsTab.Objects },
    { title: 'Controls', page: LocationsTab.Controls },
    { title: 'Forms', page: LocationsTab.Forms },
    { title: 'Properties', page: LocationsTab.Properties },
  ]

  return (
    <div className="tw:flex tw:items-center tw:h-[50px] tw:min-h-[50px] tw:max-h-[50px] tw:justify-start tw:relative tw:select-none">
      {tabObjects.map(({ title, page }) => {
        const isActive = page === activeTab
        return (
          <div
            key={page}
            className={classList({
              'tw:flex tw:items-center tw:justify-center tw:cursor-pointer tw:flex-none tw:h-full tw:max-w-[200px] tw:leading-5 tw:border-0 tw:border-b tw:border-solid': true,
              'tw:px-5 tw:text-body-md': true,
              'tw:border-primary tw:text-primary tw:font-semibold': isActive,
              'tw:border-transparent tw:text-muted-foreground': !isActive,
            })}
            onClick={() => onTabClick(page)}
          >
            {title}
          </div>
        )
      })}
    </div>
  )
}

export default observer(LocationsSetupTabs)
